// extracted by mini-css-extract-plugin
export var option = "_4y-1";
export var optionActive = "_4y-2";
export var pill = "_4y-0";